//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.General.WebApplication.index.production.ts           </Name>
//    <Description> Výchozí bundle pro prostředí production                     </Description>
//    <Author>      vnovotny                                                    </Author>
//    <Copyright>  © GORDIC spol. s r. o. 1993 - 2021                            </Copyright>
//    <Created>     2017-11-14                                                  </Created>
//  </FileHeader>

import { GLogger } from "./logr.develop";
import { IGLoggerStatic } from "./common";

let isDebug = false;

// IS_DEVELOP není nastavený, IS_DEBUG se může měnit a jeho změna způsobuje
// změnu chování objektu Logr
Object.defineProperties(window, {
    IS_DEBUG: {
        configurable: false
        , enumerable: true
        , writable: true
        , get() {
            return isDebug;
        }
        , set(value) {
            if (isDebug !== value) {
                isDebug = value;
                if (value) {
                    // todo zapnout logování
                }
                else {
                    // vypnout logování
                }
            }
        }
    }
});

window.GLogger = GLogger;




// WEBPACK FOOTER //
// ./index.production.ts